import { useEffect } from 'react';
import { useAppDispatch, useAppState } from '@/store';
import { getSuggestedFaqById, selectSuggestedFaqDetails, selectSuggestedFaqDetailsIsLoading } from '../feature';

export const useGetSuggestedFaqById = (reviewId?: string) => {
  const dispatch = useAppDispatch();
  const suggestedFaq = useAppState(selectSuggestedFaqDetails);
  const isLoading = useAppState(selectSuggestedFaqDetailsIsLoading);

  useEffect(() => {
    if (!reviewId) return;
    dispatch(getSuggestedFaqById({ reviewId }));
  }, [dispatch, reviewId]);

  return { suggestedFaq, isLoading };
};
